// Discover is restricted to a single internal account. The Feed is not.
//
// Both were closed together on 29.06.2026 (dfcd884), and that commit also hid
// "Create story" / "Create post" from the create button — so for three months
// nobody but the allow-listed account could publish, and the one screen the
// women earn from had no door. It shows in the numbers: 14.195 posts in all,
// 142 of them in 2026.
//
// 23.09.2026 (Klara): the Feed opens to every member again. Discover stays
// closed — it is a second way to browse PEOPLE, it overlaps Search (the current
// "Home"), and its rows ("Trending", "Recently active") serve whatever the
// profile table holds, which is where the dead-profile problem lives.
export const DISCOVER_EMAIL = "n.bhatt@rent24.com";

export function canViewDiscover(email: string | null | undefined): boolean {
  return (email ?? "").trim().toLowerCase() === DISCOVER_EMAIL;
}

/**
 * The feed is open to every signed-in member.
 *
 * Kept as a function, and called everywhere the old gate was called, so closing
 * it again is one edit here rather than a hunt through the nav, the guard and
 * the create button.
 */
export function canViewFeed(): boolean {
  return true;
}
